import React, { PureComponent } from "react";
import WelcomeLayout from "../../layouts/welcome";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";

class TeamReportsSection2Step1 extends PureComponent {
  get left_content() {
    const { rank_name, team_grade } = this.props;

    return (
      <span>
        <span className="welcome-percent">{team_grade.toFixed(2)}%</span>
        <span className="welcome-rank">{rank_name}</span>
      </span>
    );
  }

  get right_content() {
    return (
      <span>
        Your grade and ranking are driven by your relative
        <br />
        performance on 4 key metrics.
        <br />
        <br />
        To learn more about grading/ranking, please click here
        <i className="fa fa-long-arrow-right" />{" "}
        <TypeformLink title="Grading" url={TypeformUrls.GRADING} />.
      </span>
    );
  }

  render() {
    return (
      <WelcomeLayout
        title="Grades & Ranks"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection2Step1;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-2/step-1.js